import * as R from 'ramda';

const locationDates = (state: any) => R.pathOr('', ['mylocation', 'locationDates'], state);
const utilizationDates = (state: any) => R.pathOr('', ['mylocation', 'utilizationDates'], state);
const productivityDates = (state: any) => R.pathOr('', ['mylocation', 'productivityDates'], state);
const healthDates = (state: any) => R.pathOr('', ['mylocation', 'healthDates'], state);
const tierDates = (state: any) => R.pathOr('', ['mylocation', 'tierDates'], state);
const trendsDates = (state: any) => R.pathOr('', ['mylocation', 'trendsDates'], state);
const operationsDates = (state: any) => R.pathOr('', ['mylocation', 'operationsDates'], state);
const imcDates = (state: any) => R.pathOr('', ['mylocation', 'imcDates'], state);
const kowaDates = (state: any) => R.pathOr('', ['mylocation', 'kowaDates'], state);
const reportingDates = (state: any) => R.pathOr('', ['mylocation', 'reportingDates'], state);
const reportMiningDates = (state: any) => R.pathOr('', ['mylocation', 'reportMiningDates'], state);

const selectors = {
    locationDates, utilizationDates, productivityDates, healthDates, tierDates, trendsDates, operationsDates, imcDates, kowaDates, reportingDates, reportMiningDates
};

export default selectors;
